import { HTTP_TOKEN } from "./http";

export const getTimeLineLogs = params => {
  return HTTP_TOKEN.get("timelinelog", { params }).then(result => {
    return result.data;
  });
};

export const getTimeLineLog = (logId) => {
  return HTTP_TOKEN.get(`timelinelog/${logId}`).then(result => {
    return result.data;
  });
};

export const createTimeLineLog= data => {
  return HTTP_TOKEN.post("timelinelog", data).then(result => {
    return result.data;
  });
};

export const updateTimeLineLog = (logId, data) => {
  return HTTP_TOKEN.put(`timelinelog/${logId}`, data).then(result => {
    return result.data;
  });
};

export const deleteTimeLineLog = (logId) => {
  return HTTP_TOKEN.delete(`timelinelog/${logId}`).then(result => {
    return result.data;
  });
};


